var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-btn', {
    on: {
      "click": function ($event) {
        return _vm.$emit('cmdclick');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.caption) + " ")]);

}
var staticRenderFns = []

export { render, staticRenderFns }